export default __webpack_public_path__ + "static/media/trusona.852b2a78.svg";